export const ru = {
    'add-placements': {
        one: 'Добавьте формат щита: {formats} для увеличения охвата аудитории',
        some: 'Добавьте форматы щитов: {formats} для увеличения охвата аудитории',
        many: 'Добавьте форматы щитов: {formats} для увеличения охвата аудитории',
        none: 'Добавьте форматы щитов: {formats} для увеличения охвата аудитории'
    },
    title: 'Добавьте щиты подходящих форматов',
    'title-hint': 'Рекомендация показывается, потому что нет подходящих щитов для выбранных креативов',
    'video-format': '{width}x{height}, {duration}сек.'
};
